import { useState, useEffect } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputUploader from "../../helpers/InputUploader";


function KidsImport(props)
{

    const [tab, setTab] = useState(null);

        
    const goParse = (cr) => {
 
 
        var req = {
            crypt: cr,  
        }


        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_kids,import_kids', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                            //setTab(res.result);

                            props.mainView.showDialog( "Error",  "Dane zostały zaimportowane" , "ok" , null); 
                            props.onBack();  
                       

                        }if(res.status == 'FILETYPE') {
                                
                            props.mainView.showDialog( "Error",  "Plik nie został rozpoznany" , "ok" , null);                               

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


    const saveData = () => 
    {

    }



    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);
        goParse(crypt);
 
    }

    return         <div className="view_content">
                        <h1><PlTitle userData={props.userData} /> / Import danych dzieci</h1>

                        <div className="tip">Przed importem danych dzieci przygotuj wypełniony plik wg. wzoru. </div>
                        <br/>
                        <br/>
                        <div><a href="https://elizak.edu.pl/app/view/image/przyklad1.csv" className="link_color" target="_blank">- Pobierz wzór do wypełnienia - </a></div>

                        <br/>
                        <p>
                            Uwaga: podczas zapisu uzupełnionego pliku .csv wybierz opcje zapisz jako: <b>PLIK .CSV UTF8 - rozdzielony przecinkami.</b>
                        </p>
                        <br/>

                        <div className="form_control">
                                           
                            <InputUploader   userData={props.userData}  typ="none" typId={"-1"} remove="0" completeUpload={completeUpload} title={ "-Wybierz plik z dysku-" } max_files="1" ext="*.csv" />                    

                                                                                          
                        </div>

                        {
                                            tab != null &&
                                            <div>
                                                        <div className="form_split"></div>

                                                        <div className="form_btn">
                                                                <div className="btn" onClick={saveData}>Dodaj</div>
                                                                &nbsp;
                                                                <div className="btn" onClick={props.onBack}>Anuluj</div>
                                                        </div>
                                            </div>  
                        }

    </div>
}   

export default KidsImport;